// eslint-disable-next-line import/prefer-default-export
export const isElementEmpty = element =>
    element === null || element === undefined || element === "";
